import { render } from "./CreateOfficialMessage.vue?vue&type=template&id=b3016902&scoped=true"
import script from "./CreateOfficialMessage.vue?vue&type=script&lang=js"
export * from "./CreateOfficialMessage.vue?vue&type=script&lang=js"

import "./CreateOfficialMessage.vue?vue&type=style&index=0&id=b3016902&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3016902"]])

export default __exports__